import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = { senders: [], isLoadingSenders: false }

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_MY_MATCHES_SENDERS_START:
      return { ...state, isLoadingSenders: true }
    case types.FETCH_MY_MATCHES_SENDERS_SUCCESS:
      return {
        ...state,
        senders: action.payload,
        isLoadingSenders: false,
      }
    case types.FETCH_MY_MATCHES_SENDERS_FAILURE: {
      return { ...state, isLoadingSenders: false }
    }
    default:
      return state
  }
}

export const selectMyMatchesSenders = (store) => store.myMatchesMessaging?.senders || []

export const selectMyMatchesUnreadCount = (store) => {
  const senders = selectMyMatchesSenders(store)
  const unreadCount = senders
    .filter((sender) => {
      return sender.UnreadCount > 0
    })
    .reduce((accumulator, sender) => {
      return accumulator + sender.UnreadCount
    }, 0)
  return unreadCount || 0
}

export const selectMyMatchesUnreadCountForCollege = (store, scid) => {
  const senders = selectMyMatchesSenders(store)
  const unreadCount = senders
    .filter((sender) => sender.Scid === scid && sender.UnreadCount > 0)
    .reduce((accumulator, sender) => accumulator + sender.UnreadCount, 0)
  return unreadCount || 0
}

export const selectIsLoadingMyMatchesSenders = (store) => store.myMatchesMessaging?.isLoadingSenders || false

export default reducer
